import Offcanvas from "bootstrap/js/dist/offcanvas";
import { memo, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import SocialNav from "views/components/SocialNav";
import RootHomeNav from "views/sections/RootHomeNav";

const RootNavigation = () => {
	const location = useLocation();
	const { t } = useTranslation();

	// portal dom element
	let portalsRoot = document.getElementById("portals") || null;
	if (!portalsRoot) {
		portalsRoot = document.createElement("div");
		portalsRoot.setAttribute("id", "portals");
		document.body.appendChild(portalsRoot);
	}

	// ref hook
	const offCanvasRef = useRef(null);

	// effect hook
	useEffect(() => {
		const offCanvasCurrentElement = offCanvasRef?.current;
		let offcanvas = Offcanvas.getInstance(offCanvasCurrentElement);
		if (!offcanvas) offcanvas = new Offcanvas(offCanvasCurrentElement);
		return () => (offcanvas ? Offcanvas.getInstance(offCanvasCurrentElement).dispose() : false);
	}, [location]);

	return (
		portalsRoot &&
		ReactDOM.createPortal(
			<div
				id="root-navigation-offcanvas"
				className="offcanvas offcanvas-start border-0 shadow"
				tabIndex="-1"
				data-bs-scroll="true"
				aria-labelledby="root-navigation-offcanvas-label"
				ref={offCanvasRef}>
				<div className="offcanvas-header pb-0">
					<button
						type="button"
						className="btn-close ms-auto"
						data-bs-dismiss="offcanvas"
						aria-label={t("actions.close")}></button>
				</div>
				<div className="offcanvas-body customized-scroll px-0 py-5">
					<div className="row gx-0 h-100 flex-column flex-nowrap gy-4">
						<div className="col-12 flex-grow-1">
							<RootHomeNav isVertical fromOffcanvas />
						</div>
						<div className="col-12">
							<SocialNav variant="primary" align="text-center" size="3" spacer="mx-3" />
						</div>
					</div>
				</div>
			</div>,
			portalsRoot
		)
	);
};

export default memo(RootNavigation);
